export default {
	timeout: {
		title: "La session va bientôt expirer",
		message:
			"Vous êtes inactif depuis un moment. Par sécurité, votre session va se terminer sous peu.",
		countdown: "Fermeture dans {seconds}s",
		continue: "Rester connecté",
		logout: "Se déconnecter",
	},
	expiredByInactivity: "Votre session a été fermée pour cause d'inactivité.",
};
